import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';
import { unflatten } from 'flat';

import Loading from '../Loading';
import { Popup } from 'src/components/Popup/Popup';
import CreateRoleForm from '../CreateRoleForm';

class CreateRoleModal extends React.Component {
    static propTypes = {
        id: PropTypes.number,
        active: PropTypes.bool,
        onClose: PropTypes.func,
        onFinish: PropTypes.func,

        permissions: ImmutablePropTypes.map,
        onCreateRoleRequest: PropTypes.func
    };

    static defaultProps = {
        active: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            active: props.active
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.active) {
            this.setState({
                active: true
            });
        }
    }

    onCreate(data) {
        this.props.onCreateRoleRequest(data);
        this.setState({
            active: false
        });
    }

    render() {
        const { onClose, active } = this.props;

        return (
            <Popup
                title="Create role"
                className="create-role-modal"
                priority={ 1000 }
                active={ active }
                onClose={ onClose }
            >
                <CreateRoleForm
                    onSubmit={ this.onCreate.bind(this)}
                    permissions={ this.props.permissions }
                />
            </Popup>
        );
    }
}

export default CreateRoleModal;
